goog.provide("shadow.js.shim.module$crc_32");
goog.provide("module$shadow_js_shim_module$crc_32");
shadow.js.shim.module$crc_32 = shadow.js.nativeProvides["crc-32"] = require("crc-32");
module$shadow_js_shim_module$crc_32.default = shadow.js.shim.module$crc_32;
